import { Socket } from "rete";

export default {
  calc: new Socket("Calculation"),
  num: new Socket("Number"),
  "skim-matrix": new Socket("SkimMatrix"),
  "demand-matrix": new Socket("DemandMatrix"),
  sta: new Socket("Sta")
};
